import i18n from 'shared/lib/i18n';

export const getFeedbackTypes = () => [
  {
    label: i18n.t('common.positive'),
    value: 'true',
  },
  {
    label: i18n.t('common.negative'),
    value: 'false',
  },
];

export const SR_IMAGES_LIMIT = 10;
